import { useState, useContext, useEffect } from "react";
import { Row, Nav, Col, Button, Form, Alert, Card, Table, ButtonGroup, Modal, ProgressBar, Badge } from "react-bootstrap";

import Userprofile from "./Userprofile";

import axios from "axios";
import _ from "lodash";
import Utils from "../../common/Utils";
// import moment from "moment";
// import { useParams } from "react-router-dom";
import { UserContext } from "../../common";

// import MessageModal from "../../components/MessageModal";

const UserDocuments = (props) => {
  const { userData } = useContext(UserContext);
  // console.log(userData);
  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [nacounts,setNacounts] = useState([]);
  const [mode, setMode] = useState(0);
  const [selectedUser, setSelectedUser] = useState(0);
  const [filter, setFilter] = useState({ start: 0, limit: 10 });
  // const [message, setMessage] = useState(false);
  const [resources, setResources] = useState(false);
  const [status, setStatus] = useState(0);
  const [gapStatus, setGapStatus] = useState(0);
  const [total, setTotal] = useState(0);
  const [dtype, setDType] = useState(1);
  const [categories, setCategories] = useState([]);

  const fetchUsers = () => {
    setLoading(true);
    axios
      .get(Utils.apiUrl("users/fetchuserdocs/" + dtype), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setUsers(_.get(res, "data.users", []));
          setAllUsers(_.get(res, "data.all_users", []));
          setCategories(_.get(res, "data.categories", []));
          setTotal(_.get(res, "data.total"));
          setNacounts(_.get(res, "data.nacounts", []));
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(true);
        console.log(err);
      });
  };

  const getStat = (status) => {
    if (status == 1) {
      return "Approved Documents";
    } else if (status == 2) {
      return "Pending Documents";
    } else if (status == 3) {
      return "Disapproved Documents";
    }
  };

  const fetchUserDocByID = (id = null, status = null) => {
    // setLoading(true);
    axios
      .get(Utils.apiUrl("users/fetchuserdocbyid/") + id + "/" + status, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setResources(_.get(res, "data.users", []));
        }
        // setLoading(false);
      })
      .catch((err) => {
        // setLoading(true);
        console.log(err);
      });
  };

  useEffect(fetchUsers, [dtype]);

  const showResources = () => {
    return (
      <Modal size="xl" aria-labelledby="contained-modal-title-vcenter" centered show={true} onHide={() => setResources(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">{getStat(resources[0].doc_status)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h3>Documents</h3>
          <ol>
            {_.map(resources, (r) => (
              <li key={r.id} className="py-1">
                <a href={Utils.apiUrl("users/downloadudf") + "/" + r.file}>{r.udoc}</a>
              </li>
            ))}
          </ol>
        </Modal.Body>
      </Modal>
    );
  };

  if (!_.get(userData, "is_super_user", false)) {
    return (
      <>
        <h1 class="alert alert-danger p-5 mt-5">No access!</h1>
      </>
    );
  }

  return (
    <>
      <Row className="px-2 mt-4">
        <Col xs={6} sm={4} className="p-0 mt-1">
          <a href={`${process.env.PUBLIC_URL}/users`} className="w-100 btn btn-primary py-2">
            Manage Users
          </a>
        </Col>
        <Col xs={6} sm={4} className="px-1 mt-1">
          <a href={`${process.env.PUBLIC_URL}/roles`} className="w-100 btn py-2" style={{ backgroundColor: "#c6ddff" }}>
            Manage Roles
          </a>
        </Col>
        <Col xs={12} sm={4} className="p-0 my-1 px-1 px-sm-0">
          <a href={`${process.env.PUBLIC_URL}/helpmat`} className="w-100 btn py-2" style={{ backgroundColor: "#c6ddff" }}>
            Manage Help Materials
          </a>
        </Col>
      </Row>
      <div className="p-3 bg-white">
        {loading && (
          <Alert variant="info" className="p-3">
            <p className="loading-msg">Fetching Documents</p>
            <ProgressBar variant="info" animated now={100} />
          </Alert>
        )}
        {!loading && (
          <>
            {mode === 3 && (
              <>
                <Row>
                  <Col xs={9}>
                    <h2>User's Profile</h2>
                  </Col>
                  <Col xs={3} className="text-end">
                    <a href={`${process.env.PUBLIC_URL}/userdocument`} className="btn btn-secondary">Back</a>
                    {/*<Button variant="secondary" onClick={() => setMode(0)}>
                      Back
                    </Button>*/}
                  </Col>
                </Row>
                <Userprofile data={selectedUser} status={status} gapStatus={gapStatus} cat={dtype} />
              </>
            )}

            {mode === 0 && (
              <>
                <Row>
                  <Col xs={9}>
                    <h2>User's Profile</h2>
                  </Col>
                  <Col xs={3} className="text-end">
                    <a href={`${process.env.PUBLIC_URL}/users`}>
                      <Button variant="secondary" onClick={() => setMode(0)}>
                        Back
                      </Button>
                    </a>
                  </Col>
                </Row>
                <Nav variant="pills" className="px-" defaultActiveKey={dtype} onSelect={setDType}>
                  {_.map(categories, (cat, catidx) => (
                    <Nav.Item>
                      <Nav.Link eventKey={catidx}>{cat}</Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>

                {/* {users.length === 0 && <div className="alert alert-info p-5 text-center">No Documents added yet!</div>} */}

                {/* {users.length > 0 && ( */}
                {
                  <Table striped={true} responsive={true}>
                    <thead>
                      <tr>
                        <th style={{ width: "40px" }}>Sl.</th>
                        <th>Name</th>
                        <th className="text-center"> Total </th>
                        <th className="text-center"> Approved </th>
                        <th className="text-center"> Pending </th>
                        <th className="text-center">Disapproved </th>
                        <th className="text-center"> Expired </th>
                        <th className="text-center"> N/A </th>
                      </tr>
                    </thead>
                    <tbody>
                      {_.sortBy(
                        _.concat(
                          users,
                          allUsers.filter((item) => !users.map((item) => item.id).includes(item.id))
                        ),
                        ["name"]
                      ).map((u, idx) => (
                        <tr>
                          <td>{filter.start + idx + 1}</td>
                          <td>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedUser(u);
                                setMode(3);
                                setStatus(0);
                              }}
                            >
                              {u.name}
                            </span>
                          </td>
                          <td className="text-center">
                            {/* <div className="d-flex justify-content-end"> */}
                            <Button
                              type="button"
                              variant="contained"
                              style={{ backgroundColor: "blue", color: "white" }}
                              onClick={() => {
                                setSelectedUser(u);
                                setMode(3);
                                setStatus(0);
                              }}
                            >
                              {total}
                            </Button>
                          </td>
                          <td className="text-center">
                            <Button
                              type="button"
                              variant="contained"
                              style={{ backgroundColor: "green", color: "white" }}
                              onClick={() => {
                                setSelectedUser(u);
                                setMode(3);
                                setStatus(1);
                              }}
                            >
                              {_.get(u, "app_count", 0)}
                            </Button>
                          </td>
                          <td className="text-center">
                            <Button
                              type="button"
                              variant="contained"
                              style={{ backgroundColor: "#ffbf00", color: "white" }}
                              onClick={() => {
                                setSelectedUser(u);
                                setMode(3);
                                setStatus(2);
                              }}
                            >
                              {_.get(u, "pend_count", 0)}
                            </Button>
                          </td>
                          <td className="text-center">
                            <Button
                              type="button"
                              variant="contained"
                              style={{ backgroundColor: "maroon", color: "white" }}
                              onClick={() => {
                                setSelectedUser(u);
                                setMode(3);
                                setStatus(3);
                              }}
                            >
                              {_.get(u, "disapp_count", 0)}
                            </Button>
                          </td>

                          <td className="text-center">
                            {/* <div className="d-flex justify-content-end"> */}
                            <Button
                              type="button"
                              variant="contained"
                              style={{ backgroundColor: "red", color: "white" }}
                              onClick={() => {
                                setSelectedUser(u);
                                setMode(3);
                                setStatus(4);
                              }}
                            >
                              {_.get(u, "expire_count", 0)}
                            </Button>

                            {/* </div> */}
                          </td>
                          <td className="text-center">
                            {/* <div className="d-flex justify-content-end"> */}
                            <Button
                              type="button"
                              variant="contained"
                              style={{ backgroundColor: "grey", color: "white" }}
                              onClick={() => {
                                setSelectedUser(u);
                                setMode(3);
                                setGapStatus(4);
                              }}
                            >
                              {_.get(_.find(nacounts, n => n.user_id==u.id), "na_count", 0)}
                            </Button>

                            {/* </div> */}
                          </td>

                          
                        </tr>
                      ))}
                      
                      
                    </tbody>
                  </Table>
                }
                {_.get(resources, "length", 0) > 0 && showResources()}
              </>
            )}
          </>
        )}
      </div>

      {/* {message && (
        <MessageModal
          type={message.type}
          message={message.message}
          onHide={() => {
            setMessage(false);
          }}
        />
      )} */}
    </>
  );
};

export default UserDocuments;
